import pl from "@locales/company_settings_tabs/pl.json";
import en from "@locales/company_settings_tabs/en.json";

export default {
  pl,
  en,
};
